import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ReactNode } from 'react';

const STALE_TIME_MS = 10 * 1000;

interface Props {
    children?: ReactNode;
}

function AppQueryProvider({ children }:Props) {
  const client = new QueryClient({
    defaultOptions: {
      queries: {
        retry: 2,
        // staleTime: STALE_TIME_MS,
      },
    },
  });
  return (<QueryClientProvider client={client}>
        {children}
    </QueryClientProvider>);
}

export default AppQueryProvider;
